import { Icon, IconName } from '@usealloy/component-library';
import React from 'react';

import type { ServiceNode as IServiceNode, WorkflowNodeProps } from 'flow/service/graph';

import BaseNode from '../BaseNode';


function ServiceNode(props: WorkflowNodeProps<IServiceNode>) {
  const { id, type, data: { label } } = props;

  const isChildAccountPlaceholderList = label === 'Customer Allow List Placeholder'
    || label === 'Customer Deny List Placeholder';

  const stateStyle = isChildAccountPlaceholderList ? {
    baseBackgroundColor: '#FFFFFF',
    normal: {
      border: 'solid var(--cl-green-300)',
    },
    highlighted: {
      border: 'solid var(--cl-green-200)',
    },
    hovered: {
      border: 'solid var(--cl-green-200)',
    },
  } : {
    baseBackgroundColor: 'var(--cl-green-300)',
    highlighted: {
      backgroundColor: 'var(--cl-green-200)',
    },
    hovered: {
      backgroundColor: 'var(--cl-green-200)',
    },
  };

  return (
    <BaseNode
      icon={
        <Icon icon={IconName.Cube} size="large" />
      }
      id={id}
      label={label}
      stateStyle={stateStyle}
      type={type}
    />
  );
}

export default React.memo(ServiceNode);
